import React from "react";
import { Facebook, MessageCircle, Phone } from "lucide-react";
import { trackContactClick } from "../utils/analytics";

export default function FloatingContact() {
  const contacts = [
    {
      icon: <Phone size={22} />,
      label: "Gọi ngay",
      color: "bg-[var(--color-primary)] hover:bg-[var(--color-primary-light)]",
      link: "tel:0984842841",
    },
    {
      icon: (
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/9/91/Icon_of_Zalo.svg"
          alt="Zalo"
          className="w-6 h-6"
        />
      ),
      label: "Zalo Chat",
      color: "bg-[var(--color-primary)] hover:bg-[var(--color-primary-light)]",
      link: "https://zalo.me/0984842841",
    },
    {
      icon: <Facebook size={22} />,
      label: "Facebook",
      color: "bg-[var(--color-primary)] hover:bg-[var(--color-primary-light)]",
      link: "https://www.facebook.com/cunghome21",
    },
    {
      icon: <MessageCircle size={22} />,
      label: "Messenger",
      color: "bg-[var(--color-primary)] hover:bg-[var(--color-primary-light)]",
      link: "https://m.me/cunghome21",
    },
  ];

  return (
    <>
      <nav
        aria-label="Liên hệ nhanh"
        className="fixed inset-x-0 bottom-0 z-50 border-t border-gray-200 bg-white/95 px-3 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-2 shadow-[0_-4px_18px_rgba(0,0,0,0.12)] backdrop-blur md:hidden"
      >
        <div className="mx-auto grid max-w-md grid-cols-3 gap-2">
          {contacts
            .filter((item) => ["Gọi ngay", "Zalo Chat", "Messenger"].includes(item.label))
            .map((item) => (
              <a
                key={item.label}
                href={item.link}
                target={item.link.startsWith("http") ? "_blank" : undefined}
                rel={item.link.startsWith("http") ? "noopener noreferrer" : undefined}
                onClick={() => trackContactClick(item.label)}
                className="flex min-h-12 items-center justify-center gap-1.5 rounded-md px-1 text-xs font-semibold text-[var(--color-text)] transition active:bg-[var(--color-secondary)]"
              >
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[var(--color-primary)] text-white">
                  {item.icon}
                </span>
                <span>{item.label === "Zalo Chat" ? "Zalo" : item.label}</span>
              </a>
            ))}
        </div>
      </nav>

      <div className="fixed bottom-6 right-6 z-50 hidden flex-col items-center gap-3 md:flex">
        {contacts.map((item) => (
          <a
            key={item.label}
            href={item.link}
            target={item.link.startsWith("http") ? "_blank" : undefined}
            rel={item.link.startsWith("http") ? "noopener noreferrer" : undefined}
            title={item.label}
            aria-label={item.label}
            onClick={() => trackContactClick(item.label)}
            className={`group relative flex h-12 w-12 items-center justify-center rounded-full text-white shadow-lg transition-transform duration-200 hover:scale-105 ${item.color}`}
          >
            {item.icon}
            <span className="pointer-events-none absolute right-14 translate-x-2 whitespace-nowrap rounded-md bg-[var(--color-bg-dark)] px-3 py-1 text-xs font-medium text-white opacity-0 shadow-md transition-all duration-200 group-hover:translate-x-0 group-hover:opacity-100">
              {item.label}
            </span>
          </a>
        ))}
      </div>
    </>
  );
}
